import { RevisionDto } from '@common/services/revision';
import { buildPageableParams, Page, PageableArgs } from '../common';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { RevisedEtablissementDto } from '../etablissement';
import { servicesApi } from '../services';
import { RevisedUtilisateurDto } from '../utilisateur';
import { UtilisateurAuteurDto } from '../utilisateur/types/responses/utilisateur-auteur-dto.type';
import { OrganismeDto, RevisedOrganismeDto } from './types';

const organismeHistoriqueAction = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getOrganismeChanges: build.query<Page<RevisedOrganismeDto>, GetOrganismeChangesQueryArgs, any>({
      query: ({ id, ...pageable }) => ({
        url: `organismes/${id}/historiques`,
        params: buildPageableParams(pageable),
      }),
    }),

    getOrganismeChangesAuthors: build.query<UtilisateurAuteurDto[], { id: number }, any>({
      query: ({ id }) => ({
        url: `organismes/${id}/historiques/auteurs`,
      }),
    }),

    getAllOrganismeRevisions: build.query<RevisionDto[], GetOrganismeChangesQueryArgs, any>({
      queryFn: ({ id }, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: `organismes/${id}/revisions`,
        params: buildPageableParams({
          size: 30,
          sorters: [{ field: 'originalId.REV.id', direction: 'desc' }],
        }),
      }),
    }),

    getOrganismeRevision: build.query<OrganismeDto, { id: number, revisionId: number }, any>({
      query: ({ id, revisionId }) => ({
        url: `organismes/${id}/revisions/${revisionId}/dto`,
      }),
    }),

    getOrganismeUtilisateursChanges: build.query<Page<RevisedUtilisateurDto>, GetOrganismeUtilisateursChangesQueryArgs, any>({
      query: ({ id, ...pageable }) => ({
        url: `organismes/${id}/utilisateurs/historiques`,
        params: buildPageableParams(pageable),
      }),
    }),

    getOrganismeUtilisateursChangesAuthors: build.query<any[], { id: number }, any>({
      query: ({ id }) => ({
        url: `organismes/${id}/utilisateurs/historiques/auteurs`,
      }),
    }),

    getOrganismeEtablissementsChanges: build.query<Page<RevisedEtablissementDto>, GetOrganismeEtablissementsChangesQueryArgs, any>({
      query: ({ id, ...pageable }) => ({
        url: `organismes/${id}/etablissements/historiques`,
        params: buildPageableParams(pageable),
      }),
    }),

    getOrganismeEtablissementsChangesAuteurs: build.query<any[], { id: number }, any>({
      query: ({ id }) => ({
        url: `organismes/${id}/etablissements/historiques/auteurs`,
      }),
    }),
  }),
});

interface GetOrganismeChangesQueryArgs extends PageableArgs<any> {
  id: number;
}

interface GetOrganismeUtilisateursChangesQueryArgs extends PageableArgs<any> {
  id: number;
}

interface GetOrganismeEtablissementsChangesQueryArgs extends PageableArgs<any> {
  id: number;
}

export const {
  useGetOrganismeChangesQuery,
  useGetOrganismeChangesAuthorsQuery,
  useGetAllOrganismeRevisionsQuery,
  useGetOrganismeRevisionQuery,

  useGetOrganismeUtilisateursChangesQuery,
  useGetOrganismeUtilisateursChangesAuthorsQuery,

  useGetOrganismeEtablissementsChangesQuery,
  useGetOrganismeEtablissementsChangesAuteursQuery,
} = organismeHistoriqueAction;